import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { me } from 'lib/core/data/customer/me'
import { useCoreContext } from '../useCoreContext'

interface Params {
  onSuccess?: () => void
  onError?: () => void
}

export const useUpdateDefaultShipping = (params?: Params) => {
  const { magentoClient, onError: handleError } = useCoreContext()
  const dispatch = useDispatch()
  const [isFetching, setIsFetching] = useState(false)

  const updateDefaultShipping = (customerAddressId: number, value: boolean) => {
    setIsFetching(true)
    return magentoClient?.customer.editCustomerAddress({
      id: customerAddressId,
      setDefaultShipping: value
    })
      .then(async () => {
        await dispatch(me())
        params?.onSuccess?.()
        setIsFetching(false)
      }).catch(e => {
        params?.onError?.()
        handleError?.(e)
        setIsFetching(false)
      })
  }

  return {
    isLoading: isFetching,
    updateDefaultShipping
  }
}
